import Bowser from 'bowser';
/**
 * 优化使用最外层是绝对布局的page，在iOS平台上弹起键盘后收缩键盘，页面整体上移
 */
export default function absoluteLayoutRestPage() {
    if (Bowser.getParser(window.navigator.userAgent).getOS().name === 'iOS') {
        document.addEventListener('scroll', function (e) {
            if (document.activeElement.tagName === 'INPUT' ||
                document.activeElement.tagName === 'TEXTAREA') {
                var activeElement_1 = document.activeElement;
                function blurEvent() {
                    setTimeout(function () {
                        var scrollHeight = document.documentElement.scrollTop || window.scrollY || 0;
                        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                        activeElement_1.removeEventListener('blur', blurEvent);
                    }, 300);
                }
                activeElement_1.addEventListener('blur', blurEvent);
            }
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/m/absoluteLayoutRestPage.js
// module id = null
// module chunks = 